import { UPSELL_FALLBACK_METADATA } from "@/shared/components/UpsellPage/configs/upsellFallback.config";
import { PARENT_ROUTES, type RouteConfig } from "@/shared/configs/routeRegistry.config";
import type { UpsellCategoryKey, UpsellMetadata } from "@/shared/types/common";
import type { PlanFeatures } from "@/shared/types/planFeatures";
import { getContentFeatureAvailability } from "@/shared/utils/contentFeatureAvailability.utils";

export const getUpsellCategoryFromRoute = (
  route: RouteConfig,
): UpsellCategoryKey | undefined => {
  if (route.upsellCategory) return route.upsellCategory;
  const parentId = route.navigation?.parent;
  if (!parentId) return undefined;
  return PARENT_ROUTES[parentId]?.upsellCategory;
};

export const getUpsellMetadata = (
  category: UpsellCategoryKey | undefined,
  upsellData: Partial<Record<UpsellCategoryKey, UpsellMetadata>> | undefined,
): UpsellMetadata | undefined => {
  if (!category) return undefined;
  return upsellData?.[category] ?? UPSELL_FALLBACK_METADATA[category];
};

/** API marketing lists have text, but no stable feature identifiers. */
export const filterAvailableUpsellItems = <T extends { text: string }>(items: T[], features?: Partial<PlanFeatures>): T[] => {
  const availability = getContentFeatureAvailability(features);
  return items.filter(({ text }) =>
    (availability.polls || !/\bsondages?\b/i.test(text)) &&
    (availability.surveys || !/\benquêtes?\b/i.test(text)),
  );
};
